import type { ReactNode } from 'react';
import { useMe } from '../../api/me';
import { ForbiddenPage } from './ForbiddenPage';
import { LoadingPage } from './LoadingPage';

/** Hides admin-only pages from other users (the backend enforces the same rules). */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const me = useMe();
  if (me.isPending) return <LoadingPage />;
  if (!me.data?.admin) return <ForbiddenPage />;
  return <>{children}</>;
}
